//SVGs
import NotFound from '../svgs/NotFound';

//Components
import Button from '../components/Button';

//Router
import { useNavigate } from 'react-router-dom';

function Error404() {
  let navigate = useNavigate();

  return (
    <div className="message-info">
      <NotFound />
      <h2 className="mt-40">A página solicitada não foi encontrada</h2>
      <p className="mb-40">Pode ter sido movida ou excluída</p>
      <Button title="Retornar a home" color="red" loading={false} onClick={() => navigate("/")} />
    </div>
  );
}

export default Error404;